import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Schedule as PendingIcon,
} from "@mui/icons-material";

export const getBatchFullName = (batch) => {
  if (batch.variant && batch.variant.name) {
    return `${batch.product.event_name} - ${batch.variant.name}`;
  }
  return batch.product.event_name;
};

export const getStatusIcon = (status) => {
  switch (status) {
    case "delivered":
      return <CheckCircleIcon color="success" />;
    case "processing":
      return <PendingIcon color="warning" />;
    case "pending":
      return <PendingIcon color="action" />;
    default:
      return <ErrorIcon color="disabled" />;
  }
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
